import classNames from 'classnames'
import {useEffect, useState} from 'react'

import useMyId from '../../../../hooks/useMyId'
import {GUEST_ID, SUPER_USER_ID} from '../../../../types'
import {
  defaultThrottleTime,
  PostponeMethod,
  subscribeOnOverallEvents,
} from '../../../../utils/subscriber'
import {LINKS} from '../Header.consts'
import LinkHost from '../Links/LinkHost/LinkHost'

import styles from './InvestigationsCounter.css'

export default function InvestigationsCounter() {
  const [count, setCount] = useState(0)
  const [hasNew, setHasNew] = useState(false)
  const myId = useMyId()
  const canHaveInvestigations = myId != null && ![GUEST_ID, SUPER_USER_ID].includes(myId)
  useEffect(
    () =>
      canHaveInvestigations
        ? subscribeOnOverallEvents(
            [`investigationsCounter/${myId}`],
            message => {
              if (message == null) {
                return
              }
              const xml = new DOMParser().parseFromString(message, 'text/xml')
              const investNodes = xml.getElementsByTagName('investigations')
              if (!investNodes || investNodes.length !== 1) {
                return
              }
              setCount(Number(investNodes[0].getAttribute('activeCount')))
              setHasNew(investNodes[0].getAttribute('hasNew') === 'true')
            },
            defaultThrottleTime,
            PostponeMethod.THROTTLE,
            false,
          )
        : undefined,
    [canHaveInvestigations, myId],
  )
  let title = `My Investigations: ${count}`
  if (hasNew) {
    title += ', including new'
  }
  return (
    canHaveInvestigations && (
      <LinkHost
        to={LINKS.investigations}
        title={title}
        icon="investigation-20px"
        counter={count}
        counterClassName={classNames({[styles.new]: hasNew})}
        counterAttributes={{'data-test-investigations-badge': 'true'}}
      />
    )
  )
}
